import React, { useState, useEffect } from 'react';
import '../../LT/analyticsresults/ViewAllDetails.css';
import ButtonComponent from '../../../components/common/button/Button';
import Modal from '../../../components/common/modal/Modal';
import { useDispatch, useSelector } from "react-redux";
import { Loader } from '../../../components/common/Loader';
import { toast } from "react-toastify";
import { getLeadTimePIRData } from '../../../redux/actions/GetLeadTimePIRSlice';


const CPLeadTimeModal = ({ openLeadTimeModal, handleCloseLeadTime, data, leadTimeName }) => {

    const handleClose = () => {
        handleCloseLeadTime();
    }

    return (
        <div>
            <Modal
                className="LeadTimeModal_cls"
                open={openLeadTimeModal}
                handleClose={handleClose}
                title={leadTimeName === "ContractsLeadTime" ? "Contract Lead Time" : "PIR Lead Time"}
                action={
                    <CPLeadTimeModalFooter
                        className="viewAllDetails_cls"
                        handleCloseModal={handleClose}
                    />
                }
                content={
                    <CPLeadTimeModalContent data={data} leadTimeName={leadTimeName} />
                }
            />
        </div>
    )
}
export default CPLeadTimeModal;

const CPLeadTimeModalContent = ({ data, leadTimeName }) => {
    const [newData, setNewData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    useEffect(() => {
        getGraphData()
    }, [])
    const getGraphData = async () => {
        const endpoint = leadTimeName === "ContractsLeadTime" ? `api/lt/ltContractDetails/${data?.runOutputSeqId}` : `api/lt/ltPirDetails/${data?.runOutputSeqId}`
        try {
            const responseLeadTimePIR = await dispatch(getLeadTimePIRData({
                dynamicEndpoint: endpoint,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseLeadTimePIR.meta.requestStatus === 'fulfilled') {
                setNewData(responseLeadTimePIR?.payload);
            } else {
                toast.error(responseLeadTimePIR?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        } finally {
            setHasFetched(true); // important!
        }
    }

    return (
        (stateSelector?.GetLeadTimePIRSlice?.loading || !hasFetched) ? <Loader /> :
            <div style={{ width: 700, height: 300, position: "relative" }}>
                {leadTimeName === "ContractsLeadTime" &&
                    newData && newData?.length !== 0 ?
                    newData?.map((item, index) => {
                        return (
                            <div >
                                {index === 0 && <div className='outboundModalContent' >
                                    <p>Contract Number</p>
                                    <p>Item No</p>
                                    <p>PDT</p>
                                    <p>Last Updated on</p>
                                </div>}
                                <div className='outboundModalContent' >
                                    <span><a href={`${process.env.REACT_APP_SAP_FIORI_CONTRACT_DISPLAY_BASE_URL}?PurchaseContract=${item?.contractNumber}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{item?.contractNumber || "-"}</a></span>
                                    <span>{item?.contractItem || "-"}</span>
                                    <span> {item?.pdt ? `${item.pdt} days` : "-"}</span>
                                    <span>{item?.updatedAt || "-"}</span>
                                </div>
                            </div>)
                    }) :
                    leadTimeName === "ContractsLeadTime" && newData?.length === 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <p>No Active Contract Available now for the Supplier-Material-Incoterm Location-Plant</p></div>
                }
                {leadTimeName === "PIRLeadTime" && newData?.pirNumber?.length > 0 && hasFetched ?
                    <div >
                        <div className='outboundModalContent'>
                            <p>PIR Number</p>
                            <p>PDT</p>
                            <p>Last Updated on</p>
                        </div>
                        <div className='outboundModalContent'>
                            <span><a href={`${process.env.REACT_APP_SAP_FIORI_PIR_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#PurchasingInfoRecord-displayFactSheet?Material=${data?.materialId}&PurchasingInfoRecord=${newData?.pirNumber}&Supplier=${data?.supplierId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{newData?.pirNumber || "-"}</a></span>
                            <span>{newData?.pdt ? `${newData.pdt} days` : "-"}</span>
                            <span>{newData?.updatedAt || "-"}</span>
                        </div>
                    </div>
                    :
                    leadTimeName === "PIRLeadTime" && newData?.length === 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <p>No Active PIR Available now for the Supplier-Material-Plant/Purchasing Org</p></div>
                }
            </div>
    );
}

const CPLeadTimeModalFooter = ({ handleCloseModal }) => {
    return (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'end' }}>
            <ButtonComponent
                maxWidth="170px"
                label="Close"
                type="primary"
                onClick={handleCloseModal}
            />
        </div>
    )
}